import React from 'react'
import { Box } from '@mui/material'
import images from 'assets/images'
import SignUpBuyerOptions from 'components/pages/signup/SignUpBuyerOptions'
import HighlightChip from 'components/HighlightChip'
import SignUpProductPreview from 'components/pages/signup/SignUpProductPreview'
import SignupTemplate from 'components/templates/SignupTemplate'
import AdvantagesContainer, { Advantage } from 'components/ui/AdvantagesContainer'
import { Product } from 'type/types'

const ADVANTAGES: Advantage[] = [
  {
    image: images.signUp.DISCOUNTS,
    alt: 'Discounts',
    title: '<strong>Get discounts</strong> served on a platter',
    text: 'Every product in the NachoNacho marketplace comes with a substantial discount. Guaranteed. No haggling required.',
  },
  {
    image: images.signUp.EQUAL_OPPORTUNITY,
    alt: 'Equal Opportunity',
    title: '<strong>Equal</strong> opportunity',
    text: 'You don’t need to be funded by an elite VC firm or be part of a high-flying accelerator. The discounts on NachoNacho are available to everyone.',
  },

  {
    image: images.signUp.NO_APPLICATION_REQUIRED,
    alt: 'No Application Required',
    title: '<strong>No application</strong> required',
    text: 'Discounts are applied to your NachoNacho account automatically and seamlessly. No need to apply for discounts or even use promo and discount codes.',
  },
]

type Props = {
  product: Pick<Product, 'id' | 'name' | 'nameFile' | 'visibility' | 'offer' | 'offer2'>
}

const SignUpProduct: React.FC<Props> = ({ product }) => {
  return (
    <SignupTemplate
      left={
        <>
          <img src={images.LOGO_SYMBOL_BLUE_BACKGROUND} alt="logo" style={{ width: '110px', height: '110px' }} />

          <Box height="38px" />

          <Box className="fs-32">
            <h2 className="text-dark-blue fs-32 m-0 d-inline">Massive discounts on hundreds of SaaS products!</h2>
          </Box>

          <Box height="16px" />

          <Box maxWidth={708} display="flex" justifyContent="center">
            <HighlightChip>
              <strong>Up to 30% lifetime discounts</strong>
            </HighlightChip>
          </Box>

          <Box height="55px" />

          <AdvantagesContainer advantages={ADVANTAGES} />

          <Box height="57px" />

          <img src={images.LOGO_NN_BLUE} style={{ width: '197px' }} />
        </>
      }
      right={
        <>
          <SignUpProductPreview product={product} />
          <SignUpBuyerOptions />
        </>
      }
    />
  )
}

export default SignUpProduct
